<div
  (click)="stopClickPropagation($event)"
  [class.modal-mode]="isModalMode()"
  [class.slim-modal]="isSlimMode()"
  [attr.aria-label]="modalHeader ? modalHeader : undefined"
  [attr.aria-modal]="modalMode ? true : undefined"
  [attr.role]="modalMode ? 'dialog' : undefined"
  [cdkTrapFocus]="isModalMode()"
  class="store-wrapper {{ baseSiteService.getActive() | async }}"
  #wrapper>
  <dcp-default-modal-container></dcp-default-modal-container>
  <dcp-support-form-host></dcp-support-form-host>
  <dcp-storefront [isModal]="isModalMode()">Loading...</dcp-storefront>
</div>
